import type { ReturnReason } from './types';

export type LocalizedReasonOption = { label: string; value: string };

const FALLBACK_LANG_ORDER = ['EN_GB', 'EN_US'] as const;

export function isStorefrontReason(reason: ReturnReason): boolean {
  return reason.audiences.includes('STOREFRONT');
}

export function getReasonLabel(
  reason: ReturnReason,
  languageCode: string,
): string {
  const translations = reason.translations ?? [];

  const exact = translations.find(
    (t) => t.languageCode === languageCode,
  )?.value;
  if (exact) return exact;

  for (const fb of FALLBACK_LANG_ORDER) {
    const v = translations.find((t) => t.languageCode === fb)?.value;
    if (v) return v;
  }

  return translations[0]?.value ?? reason.id;
}

export function toLocalizedStorefrontReasonOptions(
  reasons: ReturnReason[],
  languageCode: string,
): LocalizedReasonOption[] {
  return reasons.filter(isStorefrontReason).map((reason) => ({
    value: reason.id,
    label: getReasonLabel(reason, languageCode),
  }));
}
